import { CheckoutState } from '../../state';
import {
    filterAdvancedTeamTicketsAndVariants,
    filterIndividualTickets,
} from '../../utils/tickets';

/**
 * Returns Array with all tickets available for individual registration
 */
export const getIndividualEligibleTypeTickets = (state: CheckoutState) =>
    filterAdvancedTeamTicketsAndVariants(
        state.tickets.ticketsById,
        filterIndividualTickets,
    );
